import { AbstractBulkFetch } from '../bulkFetch/abstractBulkFetch.service';
import httpService from '../http/http.service';
import KeyBy from 'lodash-es/keyBy';
import { NewsViewObject, NewsViewModel } from '@/types/apiServerContract';

class NewsFetchService extends AbstractBulkFetch<NewsViewObject> {
    protected async apiCall(ids: number[]): Promise<{ [key: number]: NewsViewObject }> {
        const result = await httpService.Post<NewsViewModel>(this.getUrl('GetSpecificNews'), { newsIds: ids });
        return KeyBy<NewsViewObject>(result.articles, 'id');
    }
}

export default new NewsFetchService('news');
